import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactForms from './components/ContactForms';
import AvailabilityStatus from './components/AvailabilityStatus';
import CalendarSection from './components/CalendarSection';
import FAQSection from './components/FAQSection';
import SocialConnect from './components/SocialConnect';

const ContactOpportunities = () => {
  useEffect(() => {
    // Set page title
    document.title = 'Contact & Opportunities - Arvin Z\'s Portfolio';
    
    // Scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Main Content */}
      <main className="pt-16">
        {/* Hero Section */}
        <ContactHero />
        
        {/* Contact Forms Section */}
        <ContactForms />
        
        {/* Availability Status */}
        <AvailabilityStatus />
        
        {/* Calendar Booking */}
        <CalendarSection />
        
        {/* FAQ Section */}
        <FAQSection />
        
        {/* Social Connect */}
        <SocialConnect />
      </main>
      {/* Footer */}
      <footer className="bg-primary text-white py-12">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-bold mb-4">Get In Touch</h3>
              <div className="space-y-2 text-white/80">
                <p>📧 arvin.zojaji@gmail.com</p>
                <p>📱 +1 (437) 833-5303</p>
                <p>🌍 Eastern Time (UTC-5)</p>
                <p>⚡ Response within 24 hours</p>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-4">Quick Links</h3>
              <div className="space-y-2">
                <a href="/" className="block text-white/80 hover:text-white transition-colors">
                  Home
                </a>
                <a href="/project-showcase-technical-case-studies" className="block text-white/80 hover:text-white transition-colors">
                  Projects
                </a>
                <a href="/technical-skills-journey" className="block text-white/80 hover:text-white transition-colors">
                  Skills
                </a>
                <a href="/code-laboratory-interactive-playground" className="block text-white/80 hover:text-white transition-colors">
                  Playground
                </a>
              </div>
            </div>

            {/* Services */}
            <div>
              <h3 className="text-lg font-bold mb-4">Services</h3>
              <div className="space-y-2 text-white/80">
                <p>Web Application Development</p>
                <p>Technical Consulting</p>
                <p>Code Reviews & Audits</p>
                <p>Speaking & Workshops</p>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60">
            <p>&copy; {new Date()?.getFullYear()} Arvin Z's Portfolio. Built with React & Tailwind CSS.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactOpportunities;